import React, { useEffect, useState } from 'react';
import { BellRing, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { api, errMsg, eur } from '../api';
import { Card, SectionTitle, inputCls, goldBtn } from '../ui';

export function AlertFields({ value, onChange, inputClass, testPrefix }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-3 text-sm">
      <label className="flex items-center gap-2"><input type="checkbox" checked={value.enabled} onChange={(e) => set('enabled', e.target.checked)} data-testid={`${testPrefix}-enabled`} />Invia l'email quando il plafond scende sotto la soglia</label>
      <div className="flex flex-wrap gap-4">
        <label className="flex items-center gap-2"><input type="radio" checked={value.mode === 'percent'} onChange={() => set('mode', 'percent')} data-testid={`${testPrefix}-mode-percent`} />Percentuale dell'ultima ricarica</label>
        <label className="flex items-center gap-2"><input type="radio" checked={value.mode === 'fixed'} onChange={() => set('mode', 'fixed')} data-testid={`${testPrefix}-mode-fixed`} />Importo fisso</label>
      </div>
      {value.mode === 'percent'
        ? <label className="flex items-center gap-2">Soglia<Input type="number" min="1" max="90" value={value.percent} onChange={(e) => set('percent', e.target.value)} className={`w-24 h-9 font-mono ${inputClass}`} data-testid={`${testPrefix}-percent`} />%</label>
        : <label className="flex items-center gap-2">Soglia<Input type="number" min="0" step="1" value={value.fixed_eur} onChange={(e) => set('fixed_eur', e.target.value)} className={`w-28 h-9 font-mono ${inputClass}`} data-testid={`${testPrefix}-fixed`} />€</label>}
    </div>
  );
}

export const toForm = (s) => ({ enabled: s.enabled, mode: s.mode, percent: s.percent, fixed_eur: (s.fixed_cents || 0) / 100 });
export const toBody = (f) => ({ enabled: f.enabled, mode: f.mode, percent: Number(f.percent), fixed_eur: Number(f.fixed_eur) });
export const describe = (s) => (s.threshold_cents == null
  ? (s.enabled ? 'La soglia sarà calcolata dalla prossima ricarica.' : 'Avviso disattivato.')
  : `Avviso sotto ${eur(s.threshold_cents)}${s.mode === 'percent' && s.base_cents ? ` (${s.percent}% di ${eur(s.base_cents)}, saldo dopo l'ultima ricarica)` : ''}.`);

export default function WalletAlertCard() {
  const [st, setSt] = useState(null);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get('/wallet/alert').then((r) => { setSt(r.data); setForm(toForm(r.data)); }).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put('/wallet/alert', toBody(form)); setSt(data); setForm(toForm(data)); toast.success('Avviso plafond salvato'); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!form) return null;
  return (
    <Card className="p-6 mb-8" data-testid="wallet-alert-card">
      <SectionTitle right={<BellRing size={16} className="text-[#D4AF37]" />}>Avviso plafond basso</SectionTitle>
      <AlertFields value={form} onChange={setForm} inputClass={inputCls} testPrefix="wallet-alert" />
      <p className="text-xs text-[#7A7F87] mt-3" data-testid="wallet-alert-threshold">{describe(st)} L'email arriva a te e in copia a Smart Info, una volta per ogni discesa sotto soglia.</p>
      <Button onClick={save} disabled={busy} className={`${goldBtn} h-10 mt-4`} data-testid="wallet-alert-save">{busy ? <Loader2 size={14} className="animate-spin" /> : 'Salva avviso'}</Button>
    </Card>
  );
}
